import "./ResetPassword.scss"
import { Button, Typography, Box, Tooltip } from "@mui/material"
import { useParams, useNavigate } from "react-router-dom"
import useFormValidation from "../../hooks/useFormValidation"
import { useTranslationLabel } from "../../hooks/useTranslationLabel"
import AppInput from "../../components/AppInput/AppInput.component"
import { useAppDispatch } from "../../redux/hooks"
import { resetPasswordAsync } from "../../redux/slices/authSlice"
import { useState } from "react"
import { ModalTypes, showModal } from "../../redux/slices/modalSlice"
import likeIcon from "../../assets/images/like.png"
import WarningIcon from "../../assets/icons/WarningIcon"
import Loader from "../../components/Loader/Loader.component"
import { ROUTES } from "../../config/routes.const"
import { useValidationSchemas } from "../../hooks/useIsValidationScehemes"

const ResetPassword = () => {
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()

  const {
    RESET_PASSWORD_PAGE_TITLE,
    INPUT_NEW_PASSWORD,
    INPUT_NEW_PASSWORD_CONFIRM,
    BTN_APPROVE,
    INPUT_PASSWORD_HINT2,
    SIMPLE_MODAL_SUCCESS_TITLE,
    CHANGE_PASSWORD_MODAL_SUCCESS_DESCRIPTION,
    SIMPLE_MODAL_ERROR_TITLE,
    SIMPLE_MODAL_ERROR_DESCRIPTION,
  } = useTranslationLabel()
  const { resetPasswordSchema, resetPasswordInitialValues } =
    useValidationSchemas()
  const { formData, errors, handleChange, validateForm } = useFormValidation(
    resetPasswordInitialValues,
    resetPasswordSchema,
  )

  const handleResetPasswordSubmit = async () => {
    if (validateForm()) {
      await dispatch(
        resetPasswordAsync({ newPassword: formData.password, token }),
      )
        .unwrap()
        .then(() => {
          dispatch(
            showModal({
              activeModal: ModalTypes.SIMPLE_MODAL,
              data: {
                title: SIMPLE_MODAL_SUCCESS_TITLE,
                description: CHANGE_PASSWORD_MODAL_SUCCESS_DESCRIPTION,
                image: likeIcon,
              },
            }),
          )
          setTimeout(() => {
            navigate(ROUTES.LOGIN)
          }, 1000)
        })
        .catch((err) => {
          dispatch(
            showModal({
              activeModal: ModalTypes.SIMPLE_MODAL,
              data: {
                title: SIMPLE_MODAL_ERROR_TITLE,
                description: SIMPLE_MODAL_ERROR_DESCRIPTION,
                image: <WarningIcon />,
              },
            }),
          )
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  return (
    <Box className="reset-password-container column center">
      {loading && <Loader />}
      <Typography variant="h5" component="h1" className="title">
        {RESET_PASSWORD_PAGE_TITLE}
      </Typography>
      <AppInput
        label={INPUT_NEW_PASSWORD}
        name="password"
        type="password"
        value={formData.password}
        error={errors.password}
        onChange={handleChange}
        endAdornment={
          <Tooltip title={INPUT_PASSWORD_HINT2} placement="top" arrow>
            <div className="tooltip">{"\u003F"}</div>
          </Tooltip>
        }
      />

      <AppInput
        label={INPUT_NEW_PASSWORD_CONFIRM}
        name="confirmPassword"
        type="password"
        value={formData.confirmPassword}
        error={errors.confirmPassword}
        onChange={handleChange}
      />

      <Button
        variant="contained"
        onClick={handleResetPasswordSubmit}
        className="primary-btn submit-btn"
      >
        {BTN_APPROVE}
      </Button>
    </Box>
  )
}

export default ResetPassword
